import React from "react";
import Slider from "react-slick";
import { motion } from "framer-motion";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Testimonial.css";

const testimonials = [
  { id: 4, video: "/Video/WhatsApp Video 2025-11-24 at 10.39.28 PM.mp4" },
  { id: 5, video: "/Video/WhatsApp Video 2025-11-24 at 10.39.31 PM.mp4" },
  { id: 6, video: "/Video/WhatsApp Video 2025-11-24 at 10.39.34 PM.mp4" },
  { id: 7, video: "/Video/WhatsApp Video 2025-11-24 at 10.39.37 PM.mp4" },
];

const Testimonials = () => {
  const sliderRef = React.useRef(null);

  const handleVideoPlay = () => {
    sliderRef.current?.slickPause();
  };

  const handleVideoPauseOrEnd = () => {
    sliderRef.current?.slickPlay();
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: true,
    pauseOnHover: true,
    cssEase: "cubic-bezier(0.4, 0, 0.2, 1)",
    responsive: [
      {
        breakpoint: 1200,
        settings: { slidesToShow: 2, arrows: true },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1, arrows: true, dots: true },
      },
    ],
  };

  return (
    <section className="testimonial-section">
      <div className="testimonial-container">
        <motion.div
          className="testimonial-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
        >
          <span className="ym-eyebrow" style={{ marginInline: "auto", background: "rgba(255,255,255,0.12)", color: "#fff" }}>
            Client testimonials
          </span>
          <h2 className="testimonial-title">What Our Clients Say</h2>
          <p className="testimonial-subtitle">
            Real stories from people who built strength, calm, and consistency with YogaMatic.
          </p>
        </motion.div>

        <div className="testimonial-slider">
          <Slider ref={sliderRef} {...settings}>
            {testimonials.map((item, index) => (
              <div key={item.id} className="testimonial-card">
                <motion.div
                  className="testimonial-card-inner"
                  initial={{ opacity: 0, y: 18 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.35 }}
                  transition={{ delay: (index % 4) * 0.05 }}
                >
                  <div className="video-container">
                    <video
                      src={item.video}
                      className="testimonial-video"
                      controls
                      loop
                      playsInline
                      onPlay={handleVideoPlay}
                      onPause={handleVideoPauseOrEnd}
                      onEnded={handleVideoPauseOrEnd}
                    />
                  </div>
                </motion.div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
